<script lang="ts">
  import { getContext } from 'svelte';
  import { isSameDay } from 'date-fns';
  import { Button } from '$lib/components/ui/button/index.js';
  import { XfaiBall } from '@/Common';
  import { findModifiedDates, getForecastResultsForChart } from '@/Util/utils';
  import type { MedianAndWeatherStores, MyFitnessStores } from './../stores';
  import AdaptForecastDialog from './AdaptForecastDialog.svelte';

  /* eslint-disable @typescript-eslint/no-explicit-any */
  // The Adapt Forecast button for a page that wants it only when it is lit: when the athlete's availability changed since
  // the plan was last saved or a day of the forecast conflicts, the same condition as the red dot on the Today page.
  // It opens the same Adapt Forecast dialog.
  export let onlyWhenNeeded = true;
  // Whether it is lit, for a page that draws its own button; showButton={false} then draws nothing.
  export let needed = false;
  export let showButton = true;

  const { trainingPlan, cal_settings } = getContext<MyFitnessStores>('myFitness');
  const { trainingMedians } = getContext<MedianAndWeatherStores>('medianAndWeather');

  let hasConflictDays = false;
  const checkConflicts = async (plan: any) => {
    const results = plan?.forecastResults ?? null;
    if (!results) return (hasConflictDays = false);
    const chart = await getForecastResultsForChart(results, plan.settings ?? null, $cal_settings, $trainingMedians, true);
    hasConflictDays = !chart.isForecastUpToDate;
  };
  $: checkConflicts($trainingPlan);

  $: lastInputs = $trainingPlan?.forecastResults?.inputs?.days ?? null;
  let upToDate = true;
  $: if ($trainingPlan?.isForecastPlan && $cal_settings?.defaults && $cal_settings?.availabilities && lastInputs) {
    upToDate = !findModifiedDates(lastInputs, $cal_settings.defaults, $cal_settings.availabilities) && !hasConflictDays;
  } else {
    upToDate = true;
  }

  $: needed = !upToDate;

  let dialog: any;
</script>

{#if showButton && (!onlyWhenNeeded || !upToDate)}
  <Button variant="outline" on:click={() => dialog.openModal()} class="group/crysball inline-flex justify-center items-center">
    <span class="relative px-[2px] pt-1 mr-1">
      <XfaiBall class="h-5" type="hover" />
      {#if !upToDate}<span class="absolute top-0.5 right-0.5 h-2 w-2 rounded-full bg-red-600" aria-hidden="true" />{/if}
    </span>
    <span>Adapt Forecast</span>
  </Button>
{/if}
{#if showButton}
  <AdaptForecastDialog bind:this={dialog} forecastData={lastInputs} />
{/if}
